import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ello': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM391.8 293.2C375.3 358.5 315.8 404.8 248 404.8S120.7 358.5 104.2 293.2C102.5 285.8 106.6 277.5 114.1 275.8 121.5 274.2 129.8 278.3 131.4 285.8 145.5 338.7 193.4 375.9 248 375.9S350.5 338.7 364.6 285.8C366.2 278.3 374.5 273.4 381.9 275.8 389.4 277.5 394.3 285.8 391.8 293.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ello.js
// module id = KSv0
// module chunks = 144